import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import { List, arrayMove } from 'react-movable';

export class CategorySortModal extends React.Component {

  state = {
    categories: []
  }

  componentWillMount() {
    this.fetchCategoryData();
  }

  fetchCategoryData = async () => {
    axios.get('/categories?displaySort=true')
      .then(data => {
        this.setState({
          categories: data
        });
      })
      .catch(err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to fetch categories')
      })
  }

  saveChanges = async () => {
    let requestParams = {
      'orderedCategories': this.state.categories
    }
    axios.post('/categories/displayorder', requestParams)
          .then(data => {
            this.props.closeModal()
            toast.success('Display order saved!')
          })
          .catch(err => {
            console.error(err); 
            Rollbar.error(err)
            toast.error("Error: Could not save display order!");
          })
  }

  render() {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Display Order</h5>
            <button type="button" className="close" onClick={this.props.closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
          <div
            style={{
              zIndex: 10000000001
            }}
          >
            <List
              lockVertically
              values={this.state.categories}
              onChange={({ oldIndex, newIndex }) =>
                this.setState({categories: arrayMove(this.state.categories, oldIndex, newIndex)})
              }
              renderList={({ children, props, isDragged }) => (
                <ul
                  {...props}
                  style={{ padding: 0, zIndex: 10000000001, cursor: isDragged ? 'grabbing' : undefined }}
                >
                  {children}
                </ul>
              )}
              renderItem={({ value, props, isDragged, isSelected }) => (
                <li
                  {...props}
                  style={{
                    ...props.style,
                    padding: '1em',
                    margin: '0.5em 0em',
                    listStyleType: 'none',
                    cursor: isDragged ? 'grabbing' : 'grab',
                    border: '2px solid #CCC',
                    color: '#333',
                    borderRadius: '5px',
                    backgroundColor: isDragged || isSelected ? '#EEE' : '#FFF',
                    zIndex: 10000000001
                  }}
                >
                  <i className="fa fa-arrows-v mr-2"></i>
                  {value.name}
                </li>
              )}
            />
          </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Close</button>
            <button type="button" onClick={this.saveChanges} className="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    );
  }
}